import React from 'react';
import Hero from '../../components/Hero';
import About from '../../components/About';
import Features from '../../components/Features';
import Services from '../../components/Services';
import SectorsSection from '../../components/SectorsSection';
import NewsSection from '../../components/NewsSection';
import Testimonials from '../../components/Testimonials';
import CTABanner from '../../components/CTABanner';
import SEO from '../../components/SEO';

export default function HomePage() {
  return (
    <>
      <SEO
        title="Whales Advisory | Clear Advice. Practical Solutions."
        description="Whales Advisory provides strategic legal and corporate advisory services, helping clients navigate complex transactions, regulation, and disputes."
        canonicalPath="/"
      />
      <Hero />
      <About />
      <Features />
      <SectorsSection />
      <Services />
      <NewsSection />
      <Testimonials />
      <CTABanner />
    </>
  );
}

